import style from './QuestionTooltip.module.css';

interface QuestionTooltipProps {
  text: string;
  leftOffset?: number;
}

export default function QuestionTooltip(props: QuestionTooltipProps) {
  return (
    <div
      className={style.tooltipContainer}
      style={{
        ['--leftOffset' as string]: `${props.leftOffset ? props.leftOffset + 4 : props.leftOffset}px`,
      }}
    >
      <div className={style.bubble}>{props.text}</div>
    </div>
  );
}
